import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewProgressReportComponent } from './new-progress-report.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAutocompleteModule, DxHtmlEditorModule, DxToolbarModule, DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule, DxTagBoxModule, DxTextBoxModule, DxGalleryModule, DxDataGridModule, DxTabPanelModule, DxTileViewModule, DxNumberBoxModule, DxAccordionModule, DxSelectBoxModule, DxRadioGroupModule, DxFileUploaderModule, DxTooltipModule, DxCheckBoxModule } from 'devextreme-angular';



@NgModule({
  declarations: [NewProgressReportComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextAreaModule,
    DxButtonModule,
    DxAutocompleteModule,
    DxHtmlEditorModule,
    DxToolbarModule,
    DxTagBoxModule,
    DxTextBoxModule,
    DxGalleryModule,
    DxDataGridModule,
    DxTabPanelModule,
    DxTileViewModule,
    DxNumberBoxModule,
    DxAccordionModule,
    DxSelectBoxModule,
    DxRadioGroupModule,
    DxFileUploaderModule,
    DxTooltipModule,
    DxCheckBoxModule

  ], 
  exports: [NewProgressReportComponent]
})
export class NewProgressReportModule { }
